module.exports = __webpack_public_path__ + "img/graphqllogo.c8a89dae.png";